import React from "react";
import { useLanguage } from "../context/LanguageContext";

const LanguageSwitcher = ({ mobile = false }) => {
  const { currentLanguage, changeLanguage } = useLanguage();

  return (
    <div className={`language-switcher ${mobile ? "mobile-language" : ""}`}>
      <button
        className={`language-btn ${currentLanguage === "id" ? "active" : ""}`}
        onClick={() => changeLanguage("id")}
        data-lang="id"
      >
        ID
      </button>
      <span className="language-separator">|</span>
      <button
        className={`language-btn ${currentLanguage === "en" ? "active" : ""}`}
        onClick={() => changeLanguage("en")}
        data-lang="en"
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
